export const parseJson = (json, def) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return def || null;
  }
};
